module.exports = __webpack_public_path__ + "img/honor2.716af78a.png";